import { Component, ElementRef, HostListener, OnDestroy, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  Router
} from "@angular/router";
//import { CookieService } from 'angular2-cookie/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { CacheService } from "../../shared/services/cache.service";
import { DataShareService } from "../../shared/services/data.service";
import { UserInfo } from '../interface/user-info.interface';
import { CommonService } from "../services/common.service";
import { MessageService } from '../services/message.service';
import { AppService } from './../../app.service';
import { SSO } from './../../sso/sso.constants';
@Component({
  selector: "app-header",
  templateUrl: '../templates/template1/views/app-header.component.html',
  styleUrls: ["../templates/template1/themes/default/CSS/app-header.less"],
  // host: {
  //   '(document:click)': 'onClick($event)',
  // }
})
export class AppHeaderComponent implements OnInit, OnDestroy {

  local: any = localStorage;
  eventSubscription: any;
  appSites: any;
  searchCountry: string = "";
  countryName: string;
  fboSite: any;
  _userInfo: any;
  initSite: any;
  topNav: boolean;
  isShowSearch: boolean = false;
  categories: string[] = [];
  category: string = "";
  selectedCountry: any = {
    countryCode: "",
    countryName: "",
    preferredLanguages: []
  };
  selectedLanguage: any;
  defaultLanguage: any;
  selectedLanguageName: any;
  languages: any = [];
  continents: any[] = [];
  quantity: number = 0;
  homeRoute: string;
  loggedIN: boolean;
  userName: any = "";
  userInfo: UserInfo;
  dropDown: boolean = false;
  isLoginMenuOpen: boolean = false;
  firstName: any = "";
  lastName: any = "";
  customerName: string = environment.customerName;
  cookieService: CookieService = new CookieService(document);
  notificationsOptions = {
    position: ["top", "right"],
    lastOnBottom: true,
    preventLastDuplicates: 'visible',
    preventDuplicates: true,
    maxStack: 1
  };
  constructor(private _appService: AppService,
    private _commonService: CommonService,
    private _cacheService: CacheService,
    private _router: Router,
    private _route: ActivatedRoute,
    //private cookie: CookieService,
    private _translate: TranslateService,
    private _dataShareService: DataShareService,
    private _eref: ElementRef,
    private _messageService: MessageService
  ) {

  }

  ngOnInit() {

    this.getSSOData();
    this.getLogoutStatus();

  }

  getSSOData() {
    //this._cacheService.get(CacheKey.AccessToken
    let accessToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);
    if (accessToken) {
      this.loggedIN = true;
      this.userInfo = this._cacheService.get(CacheKey.UserInfo);
      this._cacheService.set(CacheKey.UserId, this.userInfo.userId)
      this.lastName = this.userInfo.lastName;
      this.userName = this.userInfo.userName;
      this.firstName = this.userInfo.firstName;
    }
    else {
      this.loggedIN = false;
    }
  }



  /**
     * keyclock login
     * @returns void
     */
  login(): void {
    if (SSO.isRemoveObsoleteCookie()) {
      localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      localStorage.removeItem(SSO.INTERNAL_REFRESH_TOKEN);
      localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
      localStorage.removeItem(SSO.IS_NEW_TOKEN);
      this.cookieService.delete(SSO.INTERNAL_MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    } else {
      this.cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.INTERNAL_REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
    }
    //this._cacheService.remove(CacheKey.AccessToken);
    this._cacheService.set(CacheKey.Nav_path, JSON.stringify(window.location.pathname + window.location.search));
    window.location.href = SSO.getSSOLoginUrl();
  }
  
  logout(): void {
    this._cacheService.remove(CacheKey.RetirementModal);
    const userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo && userInfo.userName) {
      this._commonService.clearKeyCloakCache(userInfo.userName)
        .subscribe((response: any) => {
          this.logoutSettings();
        }, error => {
          this.logoutSettings();
        });
    } else {
      this.logoutSettings()
    }
  }


  /**
  * keyclock logout
  * @returns void
  */
  logoutSettings(): void {

    this._cacheService.remove(CacheKey.AccessToken);
    this._cacheService.remove(CacheKey.RefreshToken);
    this._cacheService.remove(CacheKey.CountryName);
    this._cacheService.remove(CacheKey.Id_Nonce)
    this._cacheService.remove(CacheKey.Language);
    this._cacheService.remove(CacheKey.UserPermissions);
    this._cacheService.remove(CacheKey.UserInfo);
    this._cacheService.remove(CacheKey.SelectedPOSLocation);
    this._cacheService.remove(CacheKey.Nav_path);
    this._cacheService.remove(CacheKey.UserSearch);
    this._cacheService.remove(CacheKey.DocumentLibrary);
    this._cacheService.remove(CacheKey.StoreUserSearch);
    this._cacheService.remove(CacheKey.RoleSearch);
    this._cacheService.remove(CacheKey.StoreId);
    this._cacheService.remove(CacheKey.UserName);
    this._cacheService.remove(CacheKey.UserId);
    this._cacheService.remove(CacheKey.PaymentMethodSearch);
    this._cacheService.remove(CacheKey.PaymentProcessorSearch);
    this._cacheService.remove(CacheKey.PaymentProcessorSearch);
    this._cacheService.remove(CacheKey.Store);
    this._cacheService.remove(CacheKey.SideMenuPosition);
    localStorage.clear();
    this._cacheService.set(CacheKey.IsRefreshed, true);
    if (SSO.isRemoveObsoleteCookie()) {
      localStorage.removeItem(SSO.INTERNAL_ACCESS_TOKEN);
      localStorage.removeItem(SSO.INTERNAL_REFRESH_TOKEN);
      localStorage.removeItem(SSO.LOCAL_MEMBER_SESSION_ID);
      localStorage.removeItem(SSO.IS_NEW_TOKEN);
      this.cookieService.delete(SSO.INTERNAL_MEMBER_SESSIONID, environment.cookiePath, environment.cookieDomain);
    } else {
      this.cookieService.delete(SSO.INTERNAL_ACCESS_TOKEN, environment.cookiePath, environment.cookieDomain);
      this.cookieService.delete(SSO.INTERNAL_REFRESH_TOKEN, environment.cookiePath, environment.cookieDomain);
    }
    this.cookieService.delete(SSO.INTERNAL_NONCE, environment.cookiePath, environment.cookieDomain);
    this.cookieService.delete(SSO.AuthorizedUser_UAT, environment.cookiePath, environment.cookieDomain);
    this._cacheService.remove(CacheKey.RetirementModal);
    window.location.href = SSO.getSSOLogoutUrl();
  }

  /**
    * open dropdown on click
    * @returns void
    */
  openDropdown(): void {

    this.dropDown = true;
  }


  /**
     * To navigate to account settings 
     * @returns void
     */
  navigateToAccountSettings(): void {

    this._cacheService.set(CacheKey.SideMenuPosition, CommonConstant.Account_Settings);
    this._dataShareService.changeMessage(CommonConstant.Account_Settings);
    this._router.navigate(['/admin/useradministration/userprofile']);
  }

  /**
     * To show country selection popup
     * @param  {any} element
     * @param  {boolean} isShow
     */
  showPopup(element: any, isShow: boolean) {

    if (isShow) {
      element.classList.add("scaleup");
    } else {
      element.classList.remove("scaleup");
      this.searchCountry = "";
    }
  };

  /**
   * To Destroy 
   * @returns void
   */
  ngOnDestroy(): void {

    this.eventSubscription.unsubscribe();
  };

  /**
   * In chrome and some browser scroll is given to body tag
   * @param  {any} $event
   */
  @HostListener("window:scroll", ["$event"])
  onWindowScroll($event: any) {

    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      $event.currentTarget.pageYOffset;
    let max = document.documentElement.scrollHeight;
    if (pos > 50) {
      this.topNav = true;
    } else {
      this.topNav = false;
    }
    this._commonService.getEmitter("navScroll").emit(this.topNav);
  }

  loginMenuEvent() {

    let panelBody = document.getElementById('login-menu');
    if (panelBody.classList.contains('open')) {  // To check    
      this.isLoginMenuOpen = true;
    }
    else {
      this.isLoginMenuOpen = false;
    }
  }
  showOrHideMyAccount(show: boolean) {

    let panelBody = document.getElementById('login-menu');
    if (!show) {
      this.isLoginMenuOpen = false;
      panelBody.classList.remove('open');

    } else {
      this.isLoginMenuOpen = true;
      panelBody.classList.add('open');
    }
  }

  getLogoutStatus() {
    this._messageService.getNotifyLogoutStatus().subscribe((isLogout: boolean) => {
      if (isLogout) {
        this.logout();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-header.component.ts